import _ from "lodash";
import NoItemsRow from "../NoItemsRow";
import Styles from "./ListView.module.css";
import ListViewHeaderSort from "../tables/ListViewHeaderSort";
import { InformationCircleIcon } from "../icons/Solid";
import Tooltip from "../tooltip/Tooltip";

export default function SortingListView({
	actionColumn,
	children,
	items: listItems,
	columns,
	className,
	title,
	viewList,
	sortBy,
	setSortBy,
	sortType,
	setSortType,
	...props
}) {
	if (typeof actionColumn === "undefined") actionColumn = true;
	const remappedColumns = columns?.reduce((acc, column) => {
		if (column instanceof Object && column?.title) {
			acc.push(column);
		}
		if (column instanceof Object && !column?.title) {
			if (column?.hidden) acc.push({ title: "", ...column });
			else acc.push(column);
		}
		return acc;
	}, []);

	const gridColumns = remappedColumns
		?.map((column, index) => {
			if (index === 0 && actionColumn) return "1fr";
			if (index === columns.length - 1) return "2fr";
			return "3fr";
		})
		.join(" ");

	return (
		<div className={Styles["list-view"]}>
			<div
				className={Styles["sortList-view-header"]}
				style={{ gridTemplateColumns: gridColumns }}
			>
				{remappedColumns?.map((column, index) => {
					return (
						<div className={Styles["list-view-column"]}>
							<h5>
								{column?.title && column?.sort && (
									<ListViewHeaderSort
										title={column?.title}
										code={column?.code}
										sortBy={sortBy}
										setSortBy={setSortBy}
										sortType={sortType}
										setSortType={setSortType}
									/>
								)}
								{column?.title && !column?.sort && column?.info && (
									<div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
										<Tooltip content={column.info}>
											<InformationCircleIcon
												style={{ height: "1.2em", marginRight: "0.5em", float: "left" }}
											/>
											{column?.title}
										</Tooltip>
									</div>
								)}
								{column?.title && !column?.sort && !column?.info && <div>{column?.title}</div>}
								{index === remappedColumns.length - 1 ? viewList : null}
							</h5>
						</div>
					);
				})}
			</div>

			{listItems?.length === 0 ? (
				<NoItemsRow
					name={title}
					as={"div"}
					className={""}
				/>
			) : null}
			{listItems}
			{children}
		</div>
	);
}
